/* unplugin-vue-components disabled */import script from "./PwaGuideInIos.vue?vue&type=script&setup=true&lang=js"
export * from "./PwaGuideInIos.vue?vue&type=script&setup=true&lang=js"

import "./PwaGuideInIos.vue?vue&type=style&index=0&id=d5d5fbf8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d5fbf8"]])

export default __exports__